export default __webpack_public_path__ + "static/setup_vscode_toit_extension-f562ba7f8b512efb7db0d7d39d4e265c.png";